import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'
import App from './App.jsx'
import MobileGate from './components/MobileGate.jsx'
import { loadGoogleMaps } from './lib/googleMaps'

// Defensive: the app has never intentionally registered a service worker.
// If a previous deploy (or a misbehaving extension) left one behind, unregister
// it so users don't serve stale shells indefinitely.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {})
}

loadGoogleMaps(import.meta.env.VITE_GOOGLE_MAPS_KEY)

// Detect Stripe redirect return — call save-payment-method then clean URL
;(async () => {
  try {
    const url = new URL(window.location.href)
    const piId = url.searchParams.get('payment_intent')
    const status = url.searchParams.get('redirect_status')
    if (piId && status === 'succeeded') {
      const sessionId =
        sessionStorage.getItem('brite-onboarding-session-id') || undefined
      const base = import.meta.env.VITE_ONBOARDING_API_URL || ''
      const res = await fetch(`${base}/save-payment-method`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ paymentIntentId: piId, sessionId }),
      })
      if (res.ok) {
        const data = await res.json()
        const { useOnboardingStore } = await import('./stores/onboardingStore')
        useOnboardingStore.getState().updateFormData('stripe', {
          paymentMethodId: data.paymentMethodId,
          stripeCustomerId: data.customerId,
          card: data.card || null,
        })
      }
      url.searchParams.delete('payment_intent')
      url.searchParams.delete('payment_intent_client_secret')
      url.searchParams.delete('redirect_status')
      url.searchParams.delete('setup_intent')
      url.searchParams.delete('setup_intent_client_secret')
      window.history.replaceState({}, '', url.toString())
    }
  } catch (e) {
    console.warn('[stripe-return] failed:', e)
  }
})()

const queryClient = new QueryClient()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Toaster richColors position="top-right" />
      <MobileGate>
        <App />
      </MobileGate>
    </QueryClientProvider>
  </StrictMode>,
)
